/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raw_Tame_Bee_LimpInputs */

const en_raw_tame_bee_limp = /** @type {(inputs: Raw_Tame_Bee_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participants`)
};

const de_raw_tame_bee_limp = /** @type {(inputs: Raw_Tame_Bee_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnehmer`)
};

/**
* | output |
* | --- |
* | "Participants" |
*
* @param {Raw_Tame_Bee_LimpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const raw_tame_bee_limp = /** @type {((inputs?: Raw_Tame_Bee_LimpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raw_Tame_Bee_LimpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_raw_tame_bee_limp(inputs)
	return de_raw_tame_bee_limp(inputs)
});